export class Setor {
  ativo: boolean;
  id: number;
  setor: string;
  divisaoId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/shared/setor.model.ts
 **/